import script from "./relogin.vue?vue&type=script&setup=true&lang=js"
export * from "./relogin.vue?vue&type=script&setup=true&lang=js"

import "./relogin.vue?vue&type=style&index=0&id=3bca8c98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bca8c98"]])

export default __exports__